// extracted by mini-css-extract-plugin
module.exports = {"Song":"Song_Song__1fBX6","Info":"Song_Info__11UYV","Title":"Song_Title__QgC-S","Artist":"Song_Artist__20dj_","Cover":"Song_Cover__34zcq","Options":"Song_Options__38ZUf"};